import React, {useEffect, useMemo, useState} from 'react';
import './blogPage.css'
import PageHeader from "../../layouts/home/PageHeader";
import {Container, Row, Col, Image } from "react-bootstrap";
import SearchBox from "../../components/accesories/search/SearchBox";
import Categories from "../../components/accesories/sideElements/Categories";
import KeyWords from "../../components/accesories/sideElements/KeyWords";
import RecentBlogs from "../../components/accesories/sideElements/RecentBlogs";
import {Link, useParams} from "react-router-dom";
import DOMPurify from "dompurify";
import apiRequest from "../../services/Axios/Configs/configs";
import {useData} from "../../context/DataContext";

function BlogPage(props) {

    const {id} = useParams('id')
    const[blog, setBlog] = useState({})
    const [categories, setCategories] = useState([])
    const {data, fetchData, loading} = useData();
    const[latestBlogs, setLatestBlogs] = useState([])

    /*useEffect(() => {
        apiRequest.get(`blog/${id}`)
            .then(response => {
                setBlog(response.data)
                setSafeHtml(response.data.description)
            })
            .catch(error => console.error(error));
    }, []);*/

    useEffect(() => {
        if (data.blogsCategory.length === 0) {  // چک می‌کنیم که آرایه خالی نباشد
            fetchData("blogsCategory", `blogs/blog-category/`);
        } else {
            setCategories(data.blogsCategory);
        }
    }, [data.blogsCategory]); // وابسته به `data.blogs`

    useEffect(() => {
        if (data.latestBlogs.length === 0) {
            fetchData("latestBlogs", `blogs/latest-blog/`);
        } else {
            setLatestBlogs(data.latestBlogs);
        }
    }, [data.latestBlogs]);

    useEffect(() => {
        apiRequest.get(`blogs/${id}/`).then(response => {
            setBlog(response.data)
        })
            .catch(error => console.error(error));

    }, [id]);


    const keywords = useMemo(() => {
        return blog.keywords ? blog.keywords.split("،").map(item => item.trim()) : [];
    }, [blog.keywords])

    return (
        <>
            <PageHeader mainTitle={'جزئیات مقاله'} currentPage={'جزئیات مقاله'}
                        navigationLinks={[{title: 'صفحه اصلی', href: '/'}, {title: 'مقالات', href: '/blogs'}]}/>
            <Container className={'blog-content-container p-md-5'} fluid>
                <Row className={'content-main-row flex-column-reverse flex-lg-row'}>
                    <Col xl={3} lg={4} sm={12} className={'content-right-col '}>
                        <SearchBox/>
                        <Col className={'mt-3'} sm={12}>
                            <Categories bgColor={"#FFEFF8FF"} categories={categories} directory={'blogs'}/>
                        </Col>
                        <Col className={'mt-3'} sm={12}>
                            <RecentBlogs blogs={latestBlogs}/>
                        </Col>
                        <Col className={'mt-3'} sm={12}>
                            <KeyWords keywords={keywords}/>
                        </Col>
                    </Col>
                    <Col xl={9} lg={8} sm={12} className={'content-left-col'}>
                        <Row className={'blog-page-content mb-5 p-1 p-md-4'}>
                            <div className={'blog-page-image-wrapper'}>
                                <Image src={blog.image}/>
                            </div>
                            <div className={'blog-page-detail-wrapper my-4'}>
                                <p className={'m-0'}>{blog.publication_date}</p>
                                <Link to={`/blogs/category/${blog.category_id}/posts/`}>{blog.category}</Link>
                            </div>
                            <div className="blog-page-description-wrapper">
                                <h1 className={'mb-4'}>{blog.title}</h1>
                                <div className="plog-page-description" dangerouslySetInnerHTML={{ __html: blog.description}}>
                                </div>
                            </div>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default BlogPage;